import "core-js/modules/es.array.map.js";
import React from 'react';
import { Globe } from '@finect/tabular-icons/globe';
import { withTheme } from 'styled-components';
import { InlineFlex } from './partials';
var scale = [1, 2, 3, 4, 5];
export var ESGRating = function ESGRating(_ref) {
  var value = _ref.value,
    theme = _ref.theme;
  var score = value.score;
  var _theme$colors = theme.colors,
    uiD = _theme$colors.uiD,
    positive = _theme$colors.positive;
  return React.createElement(InlineFlex, null, scale.map(function (item) {
    return React.createElement(Globe, {
      size: "18",
      key: item,
      color: item <= score ? positive : uiD
    });
  }));
};
export default withTheme(ESGRating);